import { useState, useEffect, useMemo } from 'react';

import get from 'lodash/get';

import { isEqualFilterValues, set } from '../utils';

const useStateManager = ({
  controlled,
  initialValues,
  emptyValues,
  initialDirty = false,
  onChange,
  onApply,
}) => {
  const [stateValues, setStateValues] = useState(initialValues);

  const values = controlled ? initialValues : stateValues;

  useEffect(() => {
    if (!controlled) {
      setStateValues(initialValues);
    }
  }, [JSON.stringify(initialValues)]);

  const setFilterValue = (path, v) => {
    const newValues = set(values, path, v);

    if (!controlled) {
      setStateValues(newValues);
    }

    onChange?.(newValues);
  };

  const setFilterValues = (values) => {
    if (!controlled) {
      setStateValues(values);
    }

    onChange?.(values);
  };

  const getFilterValue = (path) => {
    return get(values, path);
  };

  const getFilterEmptyValue = (path) => {
    return get(emptyValues, path);
  };

  const getFilterValues = () => {
    return values;
  };

  const dirty = useMemo(() => {
    if (controlled) {
      return initialDirty;
    } else if (isEqualFilterValues(values, initialValues)) {
      return initialDirty;
    } else {
      return true;
    }

    // return controlled
    //   ? initialDirty
    //   : !isEqualFilterValues(values, initialValues);
  }, [controlled, initialDirty, values, initialValues]);

  const handleClearFilters = () => {
    if (clear) {
      setFilterValues(emptyValues);
    }
  };

  const clear = useMemo(() => {
    return !isEqualFilterValues(values, emptyValues);
  }, [values, emptyValues]);

  const handleApplyFilters = () => {
    onApply(values);
  };

  return {
    values,
    setFilterValue,
    setFilterValues,
    getFilterValue,
    getFilterValues,
    getFilterEmptyValue,
    onClearFilters: handleClearFilters,
    onApplyFilters: handleApplyFilters,
    clear,
    dirty,
  };
};

export default useStateManager;
